<div class="page-wrapper pt-4">
  <div class="dashboard-content">
    <!-- Header Section -->
    <div class="d-flex justify-content-between align-items-start mb-4">
      <div>
        <h1 class="dashboard-title">Regional Education Strategic Dashboard</h1>
        <p class="dashboard-subtitle">National Oversight &amp; Institution Performance Metrics</p>
      </div>
      <!-- <div class="d-flex align-items-center gap-2">
        <span class="academic-year-label">Academic Year:</span>
        <select class="form-select form-select-sm academic-year-select">
          <option selected>2024/2025</option>
          <option>2023/2024</option>
          <option>2022/2023</option>
        </select>
      </div> -->
    </div>

    <!-- Jurisdiction Section -->
    <div class="row mb-4">
      <!-- Current Jurisdiction Card -->
      <div class="col-lg-4 col-md-5 mb-3">
        <div class="jurisdiction-card">
          <span class="jurisdiction-badge">CURRENT JURISDICTION</span>
          <h1 class="jurisdiction-name">{{ countyAndRegionList[0]?.REGION_NAME }}</h1>
          <div class="reporting-badge">
            <i class="bi bi-diagram-3-fill me-2"></i>
            Reporting to: National Oversight (RDE)
          </div>
        </div>
      </div>

      <!-- Jurisdiction Scope Card -->
      <div class="col-lg-8 col-md-7 mb-3">
        <div class="scope-card">
          <h6 class="scope-title">JURISDICTION SCOPE (COUNTIES)</h6>

          <div class="d-flex flex-wrap gap-2 mt-3">
            <span class="county-badge" *ngFor="let county of countyAndRegionList">
              {{ county.COUNTIES_NAME }}
            </span>
          </div>

        </div>
      </div>
    </div>

    <!-- KPI Cards -->
    <div class="row g-3">
      <div class="col">
        <div class="kpi-card">
          <p class="kpi-label">Approved Institutions<br>(KEMIS)</p>
          <h3 class="kpi-value kpi-value-blue">{{ dashboardDetails?.TOTAL_INSITUTIONS?.total || 0 }}</h3>
          <!-- <div class="kpi-footer kpi-footer-blue">
            <i class="bi bi-graph-up-arrow me-1"></i>
            <span>+4.2% YoY</span>
          </div> -->
        </div>
      </div>

      <div class="col">
        <div class="kpi-card">
          <p class="kpi-label">Total Students<br>Enrollment</p>
          <h3 class="kpi-value kpi-value-blue">{{ dashboardDetails?.TOTAL_LEARNERS?.total || 0 }}</h3>
          <!-- <div class="kpi-footer kpi-footer-blue">
            <i class="bi bi-graph-up-arrow me-1"></i>
            <span>+1.8% YoY</span>
          </div> -->
        </div>
      </div>

      <div class="col">
        <div class="kpi-card">
          <p class="kpi-label">Total Applications</p>
          <h3 class="kpi-value kpi-value-blue">{{ dashboardDetails?.TOTAL_INSITUTIONS?.pending || 0 }}</h3>
          <!-- <div class="kpi-footer kpi-footer-blue">
            <i class="bi bi-graph-up-arrow me-1"></i>
            <span>+3.5% YoY</span>
          </div> -->
        </div>
      </div>

      <div class="col">
        <div class="kpi-card kpi-card-pink">
          <p class="kpi-label">Rejected Applications</p>
          <h3 class="kpi-value kpi-value-red">{{ dashboardDetails?.TOTAL_INSITUTIONS?.reject || 0 }}</h3>
          <!-- <div class="kpi-footer kpi-footer-red">
            <i class="bi bi-exclamation-circle me-1"></i>
            <span>Requires Review</span>
          </div> -->
        </div>
      </div>

      <div class="col">
        <div class="kpi-card kpi-card-yellow">
          <p class="kpi-label">Special Need Schools</p>
          <h3 class="kpi-value kpi-value-dark">{{ dashboardDetails?.SPECIAL_NEED_SCHOOLS?.total || 0 }}</h3>
          <!-- <div class="kpi-footer kpi-footer-brown">
            <i class="bi bi-people-fill me-1"></i>
            <span>Priority Area</span>
          </div> -->
        </div>
      </div>
    </div>

    <!-- Geographic Distribution & Top Counties -->
    <div class="row g-3 mt-4">
      <!-- Map Section -->
      <div class="col-lg-8">
        <div class="map-card">
          <div class="map-header">
            <h5 class="map-title">Geographic Distribution</h5>
            <div class="map-tabs">
              <button class="map-tab active">Heatmap</button>
              <button class="map-tab">Institutions</button>
            </div>
          </div>
          <div class="map-body">
            <!-- Map Placeholder -->
            <div class="map-placeholder">
              <i class="bi bi-geo-alt-fill"></i>
              <p>RIFT VALLEY REGION, KENYA</p>
              <span>GIS DASHBOARD</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Top Counties Distribution -->
      <div class="col-lg-4">
        <div class="counties-card">
          <h5 class="counties-title">Top Counties Distribution</h5>
          <div class="county-bar-list">
            <div class="county-bar-item" *ngFor="let county of topCounties">
              <div class="county-bar-label">
                <span>{{ county.reject }}</span>
                <span class="county-bar-value"> {{county.total }}</span>
              </div>
              <div class="county-bar-track">
                <div class="county-bar-fill" [style.width.%]="county.percentage"></div>
              </div>
            </div>
          </div>
          <!-- <button class="btn-view-census">View Full Census Data</button> -->
        </div>
      </div>

    </div>

    <!-- Institutional Breakdown & Education Level Distribution -->
    <div class="row g-3 mt-4">
      <!-- Institutional Breakdown -->
      <div class="col-lg-6">
        <div class="breakdown-card">
          <div class="breakdown-header">
            <h5 class="breakdown-title">Institutional Breakdown</h5>
            <i class="bi bi-plus-circle text-muted"></i>
          </div>
          <div class="breakdown-body">
            <div class="donut-wrapper">
              <div class="donut-chart-container">
                <!-- <svg viewBox="0 0 120 120" width="150" height="150">
                  <circle cx="60" cy="60" r="50" fill="none" stroke="#e9ecef" stroke-width="14" />
                  <circle cx="60" cy="60" r="50" fill="none" stroke="#0099cc" stroke-width="14"
                    stroke-dasharray="195 119" stroke-dashoffset="0" transform="rotate(-90 60 60)" />
                  <circle cx="60" cy="60" r="50" fill="none" stroke="#d32f2f" stroke-width="14"
                    stroke-dasharray="119 195" stroke-dashoffset="-195" transform="rotate(-90 60 60)" />
                </svg> -->
                <svg viewBox="0 0 120 120" width="150" height="150">

                  <circle cx="60" cy="60" r="50" fill="none" stroke="#e9ecef" stroke-width="14">
                  </circle>

                  <!-- PUBLIC -->
                  <circle cx="60" cy="60" r="50" fill="none" stroke="#0099cc" stroke-width="14"
                    [attr.stroke-dasharray]="publicDashArray" stroke-dashoffset="0" transform="rotate(-90 60 60)">
                  </circle>

                  <!-- PRIVATE -->
                  <circle cx="60" cy="60" r="50" fill="none" stroke="#d32f2f" stroke-width="14"
                    [attr.stroke-dasharray]="privateDashArray" [attr.stroke-dashoffset]="privateDashOffset"
                    transform="rotate(-90 60 60)">
                  </circle>

                </svg>
                <div class="donut-center-text">
                  <span class="donut-number">{{ dashboardDetails?.INSTITUTIONAL_BREAKDOWN.total }}</span>
                  <span class="donut-sub">TOTAL</span>
                </div>
              </div>
            </div>
            <div class="breakdown-legend">
              <div class="legend-row">
                <span class="legend-bar legend-bar-blue"></span>
                <div>
                  <p class="legend-label">PUBLIC INSTITUTIONS</p>
                  <p class="legend-value">{{ dashboardDetails?.INSTITUTIONAL_BREAKDOWN.reject }} <span
                      class="legend-pct">({{ dashboardDetails?.INSTITUTIONAL_BREAKDOWN_PERCENTAGE.reject }}%)</span></p>
                </div>
              </div>
              <div class="legend-row">
                <span class="legend-bar legend-bar-red"></span>
                <div>
                  <p class="legend-label">PRIVATE INSTITUTIONS</p>
                  <p class="legend-value">{{ dashboardDetails?.INSTITUTIONAL_BREAKDOWN.pending }} <span
                      class="legend-pct">({{ dashboardDetails?.INSTITUTIONAL_BREAKDOWN_PERCENTAGE.pending }}%)</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Education Level Distribution -->
      <div class="col-lg-6">
        <div class="edu-level-card">
          <div class="edu-level-header">
            <h5 class="edu-level-title">Education Level Distribution</h5>
            <i class="bi bi-bar-chart-fill text-muted"></i>
          </div>

          <div class="edu-level-body">

            <div class="edu-level-item" *ngFor="let item of educationLevels">

              <span class="edu-level-name">
                {{ item.reject }}
              </span>

              <div class="edu-level-track">
                <div class="edu-level-fill" [style.width.%]="item.percentage">
                </div>
              </div>

              <span class="edu-level-val">
                {{ item.total }}
              </span>

            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Regional Admission Trends Table -->
    <div class="row mt-4">
      <div class="col-12">
        <div class="trends-card">
          <div class="trends-header">
            <div>
              <h5 class="trends-title">Regional Admission Trends</h5>
              <p class="trends-subtitle">Enrollment metrics by grade and gender parity</p>
            </div>
            <button class="btn-export">
              <i class="bi bi-download me-1"></i>
              Export CSV
            </button>
          </div>
          <div class="card-body">
            <div class="table-responsive" *ngIf="regionGradeList.length">
              <table id="patreggraph" datatable class="trends-table rde-table">
                <thead class="bg-light">
                  <tr>
                    <th>LEVEL / GRADE</th>
                    <th>MALE (ENROLLMENT)</th>
                    <th>FEMALE (ENROLLMENT)</th>
                    <th>TOTAL POPULATION</th>
                    <th>GENDER PARITY</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of regionGradeList">
                    <td class="level-name">{{item.COURSE_NAME}}</td>
                    <td>{{item.MALE}}</td>
                    <td>{{item.FEMALE}}</td>
                    <td class="total-pop">{{item.TOTAL}}</td>
                    <td><span class="parity-badge parity-green">{{item.PARITY}}</span></td>
                  </tr>

                </tbody>
              </table>
            </div>
            <div class="text-center" *ngIf="!regionGradeList.length">
              No Records to Display
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>